module.exports = __webpack_public_path__ + "img/people-working-together-2.8ab8d9ca.svg";